import { LookupItem, reportWildcards } from '@cumu/shared';
import { controller, target } from '@github/catalyst';

@controller('report-activity-parameter')
class ReportActivityParameterElement extends HTMLElement {
  @target declare definitionSelect: HTMLSelectElement;

  get organizationId() {
    return this.getAttribute('organization-id')!;
  }

  handleActivityDefinitionChange() {
    const activityDefinitionId = this.definitionSelect.value;
    if (!activityDefinitionId) {
      return;
    }

    const autocomplete = this.querySelector('auto-complete');
    if (!autocomplete) {
      throw new Error('Expected activity parameter autocomplete element.');
    }
    const src = new URL(autocomplete.getAttribute('src')!, location.href);
    src.pathname = `/api/organizations/${this.organizationId}/activity_definitions/${activityDefinitionId}/activity-select-suggestions`;
    autocomplete.setAttribute('src', `${src.pathname}?${src.searchParams}`);

    const listBox = this.querySelector('autocomplete-list-box') as
      (HTMLElement & { clear?: () => void }) | null;
    const valueInput = listBox?.querySelector<HTMLInputElement>(
      '[data-target="autocomplete-list-box.valueInput"]'
    );
    let value: LookupItem[] | null = null;
    try {
      value = valueInput?.value ? JSON.parse(valueInput.value) : null;
    } catch {
      value = null;
    }
    const onlyAllActivities =
      value?.length === 1 && value[0].id === reportWildcards.allActivities.id;
    if (!onlyAllActivities) {
      listBox?.clear?.();
    }
  }
}

declare global {
  interface Window {
    ReportActivityParameterElement: typeof ReportActivityParameterElement;
  }
  interface HTMLElementTagNameMap {
    'report-activity-parameter': ReportActivityParameterElement;
  }
}
